var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"login"},[(_vm.isLogged)?_c('span',{on:{"click":_vm.gotoProfile}},[_vm._v("Mi perfil")]):_c('span',{on:{"click":_vm.doLogin}},[_vm._v("Inicia sesión "),_c('i',{staticClass:"far fa-user-circle fa-lg"})])])}
var staticRenderFns = []

export { render, staticRenderFns }